import React from 'react';
import { motion, MotionProps } from 'framer-motion';
type Props = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
} & MotionProps;
export function GlassCard({
  children,
  className = '',
  delay = 0,
  ...rest
}: Props) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.7,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} className={`relative overflow-hidden rounded-2xl shadow-[0_10px_30px_-12px_rgba(0,0,0,0.7)] ${className}`} style={{
    background: 'linear-gradient(180deg, #052a52 0%, #03203f 100%)',
    border: '1px solid rgba(255,255,255,0.12)'
  }} {...rest} data-id="element-87">
      <div className="relative h-full w-full" data-id="element-88">{children}</div>
    </motion.div>;
}